var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.4472,
    y: 4.42773,
    width: 16.7015,
    height: 10.1064,
    rx: 1,
    stroke: "#424450"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.65189,
    y: 6.52344,
    width: 4.16762,
    height: 5.70126,
    rx: 1.9687,
    stroke: "#424450"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75729 4.50391C3.86921 5.23153 3.58931 6.68677 1.57443 6.68677",
    stroke: "#424450"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8394 14.5332C15.721 13.7634 16.0171 12.2238 18.1488 12.2238",
    stroke: "#424450"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8816 4.50391C15.7654 5.25964 16.0561 6.77111 18.1488 6.77111",
    stroke: "#424450"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75725 14.5332C3.86916 13.8056 3.58927 12.3504 1.57443 12.3504",
    stroke: "#424450"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.942 7.16406V14.267C19.942 15.3716 19.0466 16.267 17.942 16.267H3.20862",
    stroke: "#424450",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2148,
    cy: 9.36592,
    r: 0.694043,
    fill: "#424450"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.20784,
    cy: 9.36592,
    r: 0.694043,
    fill: "#424450"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.d632dc177c2f841e3b3c34fc234b9a9c.svg";
export { ForwardRef as ReactComponent };